import { defineComponent } from 'vue';
import entriesCommonMixin from './entriesCommonMixin';
import entriesLoaderMixin from './entriesLoaderMixin';
import entriesFilteringMixin from './entriesFilteringMixin';

export default defineComponent({
    mixins: [
        entriesCommonMixin,
        entriesLoaderMixin,
        entriesFilteringMixin,
    ],
    props: {
        height: {},
        disabled: Boolean,
        sortOptionList: {
            type: Array,
            required: true
        },
        listHeight: {},
        permissionAdd: Boolean,
        elementsPerRowClass: {
            type: String,
            required: true
        },
        readonly: Boolean,
        dragulaDisableCanvas: Boolean,
        elementLayerUsergroupFilteringFunction: Function
    },
    data() {
        return {
            sortOption: 2,

            userEnteredItemsMap: {
                name: [],
                tags: [],
            },

            t_sort_by: Lang.langGet("Sort by"),

            t_search: Lang.langGet("Search"),
            t_tags: Lang.langChoice("Tag|Tags", 2),
        };
    },
    computed: {
        /** Must be implemented by the component using the mixin
         * localStorageKeyDndSortOption() {}, */
        /** */
        namesWithUserEntered() {
            return this.filteredItemsWithUserEntered(this.fieldValuesMap.name, this.userEnteredItemsMap.name);
        },
        tagsWithUserEntered() {
            let returnValue = [{
                value: '§hidden',
                disabled: !this.anyEntriesHidden
            }, {
                value: '§imported',
                disabled: !this.anyEntriesImported
            }];
            const tagItems = this.filteredItemsWithUserEntered(this.fieldValuesMap.tags, this.userEnteredItemsMap.tags);

            if (tagItems) {
                returnValue = returnValue.concat(tagItems)
            }
            return returnValue
        },
    },
    methods: {
        async loadEntries(entriesFunctionOrData) {
            await this.loadData(entriesFunctionOrData);
            await this.$nextTick();
            EaseEventBus.fire('reinitializeDragula', this.dragulaDisableCanvas);
        }
    },
    watch: {
        sortOption(val) {
            localStorage.setItem(this.localStorageKeyDndSortOption, val);
        }
    },
    created() {
        this.sortOption = +(localStorage.getItem(this.localStorageKeyDndSortOption) ?? 2);
    }
});
